
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["oeamtc-button__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.5 6v1.98h9V6h1.8v1.98h.9c.99 0 1.8.777 1.8 1.727v13.566c0 .95-.81 1.727-1.8 1.727H8.8c-.99 0-1.8-.777-1.8-1.727V9.707c0-.95.81-1.727 1.8-1.727h.9V6h1.8zm11.7 6.045H8.8v11.228h14.4V12.045zm-1.386 8.272v1.7h-1.7v-1.7h1.7z"}})])
          )
        }
      }
    